module.exports = __webpack_public_path__ + "img/safety_thumb.c8f59a47.jpg";